<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/index')">首页</a-breadcrumb-item>
      <a-breadcrumb-item href="" @click.native="() => $router.push('/sick-leave-list')">申请休假</a-breadcrumb-item>
      <a-breadcrumb-item>{{ isEdit ? '补充资料' : '申请' }}</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="notice-scroll">
      <div class="notice-content">
        <span class="notice-item">
          <a-icon type="info-circle" style="color: #1890ff; margin-right: 8px;" />
          请注意：学生因病申请缓考或休、复学需上传《疾病诊断证明书》和门（急）诊就诊病历。《证明书》由经治医生签名并加盖医生所在医疗机构的医疗证明章
        </span>
        <span class="notice-item">
          <a-icon type="info-circle" style="color: #1890ff; margin-right: 8px;" />
          请注意：学生因病申请缓考或休、复学需上传《疾病诊断证明书》和门（急）诊就诊病历。《证明书》由经治医生签名并加盖医生所在医疗机构的医疗证明章
        </span>
      </div>
    </div>

    <div class="content-box">
      <div class="form-header">
        <h2>{{ isEdit ? '补充资料' : '申请' }}</h2>
      </div>

      <a-form-model ref="formRef" :model="formData" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="申请类型" prop="flowType">
          <a-select v-model="formData.flowType" placeholder="请选择申请类型" @change="handleFlowTypeChange" :disabled="isEdit">
            <a-select-option :value="1">休学</a-select-option>
            <a-select-option :value="2">复学</a-select-option>
            <a-select-option :value="4">缓考</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="学历" prop="educationBackground" v-if="formData.flowType">
          <a-select v-model="formData.educationBackground" placeholder="请选择学历">
            <a-select-option value="本科">本科</a-select-option>
            <a-select-option value="研究生">研究生</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="就诊医院" prop="visitType">
          <a-select v-model="formData.visitType" placeholder="请选择就诊医院">
            <a-select-option :value="0">校医院</a-select-option>
            <a-select-option :value="1">三方医院</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="申请单" prop="deferredExamFormNo">
          <a-input v-model="formData.deferredExamFormNo" placeholder="请选择申请单" :read-only="true"
            @click="openExamFormDrawer" style="cursor: pointer;" />
        </a-form-model-item>

        <a-form-model-item label="校医院请假单" prop="hisLeaveFormNo" v-if="formData.visitType === 0">
          <a-input v-model="medicalHistory" placeholder="请选择校医院请假单" :read-only="true" @click="openHisLeaveDrawer"
            style="cursor: pointer;" />
        </a-form-model-item>


        <a-divider v-if="formData.flowType">基本信息</a-divider>

        <a-form-model-item label="姓名" prop="name" v-if="formData.flowType && formData.flowType !== 4">
          <a-input v-model="formData.name" placeholder="请输入姓名" :disabled="isEdit"></a-input>
        </a-form-model-item>

        <a-form-model-item label="姓名" prop="name" v-if="formData.flowType === 4">
          <a-input v-model="formData.name" placeholder="请输入姓名" disabled></a-input>
        </a-form-model-item>

        <a-form-model-item label="学号" prop="studentNumber" v-if="formData.flowType">
          <a-input v-model="formData.studentNumber" placeholder="请输入学号" disabled></a-input>
        </a-form-model-item>

        <a-form-model-item label="手机号" prop="phone" v-if="formData.flowType">
          <a-input v-model="formData.phone" placeholder="请输入手机号" disabled></a-input>
        </a-form-model-item>

        <a-form-model-item label="性别" prop="gender">
          <a-select v-model="formData.gender" placeholder="请选择性别" disabled>
            <a-select-option value="1">男</a-select-option>
            <a-select-option value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>



        <a-form-model-item label="学院(系)" prop="college" v-if="formData.flowType && formData.flowType !== 4">
          <a-input v-model="formData.college" placeholder="请输入学院(系)" />
        </a-form-model-item>

        <a-form-model-item label="学院(系)" prop="college" v-if="formData.flowType === 4">
          <a-input v-model="formData.college" placeholder="请输入学院(系)" disabled />
        </a-form-model-item>

        <a-form-model-item label="专业" prop="specialty" v-if="formData.flowType && formData.flowType !== 4">
          <a-input v-model="formData.specialty" placeholder="请输入专业" />
        </a-form-model-item>

        <a-form-model-item label="专业" prop="specialty" v-if="formData.flowType === 4">
          <a-input v-model="formData.specialty" placeholder="请输入专业" disabled />
        </a-form-model-item>

        <a-form-model-item label="班级" prop="classGrade" v-if="formData.flowType && formData.flowType !== 4">
          <a-input v-model="formData.classGrade" placeholder="请输入班级" />
        </a-form-model-item>

        <a-form-model-item label="班级" prop="classGrade" v-if="formData.flowType === 4">
          <a-input v-model="formData.classGrade" placeholder="请输入班级" disabled />
        </a-form-model-item>

        <a-form-model-item label="家庭住址" prop="address" v-if="formData.flowType && formData.flowType !== 4">
          <a-input v-model="formData.address" placeholder="请输入家庭住址"></a-input>
        </a-form-model-item>

        <a-form-model-item label="休学起止时间" prop="dateRange" v-if="formData.flowType === 1">
          <a-range-picker v-model="dateRange" style="width: 100%" value-format="YYYY-MM-DD"
            @change="handleDateRangeChange"></a-range-picker>
        </a-form-model-item>

        <a-form-model-item label="复学时间" prop="beginTime" v-if="formData.flowType === 2">
          <a-date-picker v-model="formData.beginTime" style="width: 100%" value-format="YYYY-MM-DD"
            @change="handleBeginTimeChange"></a-date-picker>
        </a-form-model-item>

        <a-form-model-item label="休学情况说明" prop="description" v-if="formData.flowType === 1">
          <a-select v-model="formData.description" placeholder="请选择休学情况">
            <a-select-option v-for="item in leaveReasonList" :key="item.value" :value="item.value">{{ item.label
            }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="其他原因说明" prop="otherReason"
          v-if="formData.flowType === 1 && formData.description === '12'">
          <a-textarea v-model="formData.otherReason" placeholder="请输入其他原因说明" :rows="3"></a-textarea>
        </a-form-model-item>

        <a-form-model-item label="复学情况说明" prop="description" v-if="formData.flowType === 2">
          <a-textarea v-model="formData.description" placeholder="请输入复学情况说明" :rows="3"></a-textarea>
        </a-form-model-item>

        <a-form-model-item label="申请缓考理由" prop="reason" v-if="formData.flowType === 4">
          <a-textarea v-model="formData.reason" placeholder="请输入申请缓考理由" :rows="3" disabled></a-textarea>
        </a-form-model-item>

        <a-form-model-item label="缓考说明" prop="description" v-if="formData.flowType === 4">
          <a-textarea v-model="formData.description" placeholder="请输入缓考说明" :rows="3" disabled></a-textarea>
        </a-form-model-item>

        <a-divider v-if="formData.flowType === 4">缓考课程列表</a-divider>

        <a-table v-if="formData.flowType === 4" :columns="courseColumns" :data-source="formData.deferredExamCourseList"
          :pagination="false" bordered row-key="index"></a-table>

        <a-divider v-if="formData.flowType">上传图片</a-divider>

        <a-form-model-item label="图片上传" prop="thirdMedicalRecordList" v-if="formData.flowType">
          <a-upload action="#" list-type="picture-card" :file-list="fileList" :before-upload="beforeUpload"
            @change="handleUploadChange" @preview="handlePreview" :custom-request="handleCustomUpload">
            <div v-if="fileList.length < 9">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <div class="upload-tips">
            请上传<span class="warning">医院疾病诊断证明书、门诊病历或住院病历</span>，必要时附检查报告单（B超、CT、血液检验单），最多9张，每张大小限制在5M以内
          </div>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button type="primary" size="large" style="width: 200px" @click="handleSubmit" :loading="submitLoading">
            提交申请
          </a-button>
          <a-button size="large" style="width: 200px; margin-left: 20px" @click="handleBack">
            返回
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="preview" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-drawer title="选择申请单" :width="720" :visible="examFormDrawerVisible" @close="closeExamFormDrawer">
      <a-table :columns="examFormColumns" :data-source="examFormList" :pagination="false" :loading="examFormLoading"
        row-key="applicationId">
        <template slot="operation" slot-scope="text, record">
          <a-button type="primary" size="small" @click="selectExamForm(record)">
            选择
          </a-button>
        </template>
      </a-table>
    </a-drawer>

    <a-drawer title="选择校医院请假单" :width="720" :visible="hisLeaveDrawerVisible" @close="closeHisLeaveDrawer">
      <a-table :columns="hisLeaveColumns" :data-source="hisLeaveList" :pagination="false" :loading="hisLeaveLoading"
        row-key="id">
        <template slot="operation" slot-scope="text, record">
          <a-button type="primary" size="small" @click="selectHisLeave(record)">
            选择
          </a-button>
        </template>
      </a-table>
    </a-drawer>
  </div>
</template>

<script>
import {
  getNetworkCenterUserInfo,
  getDelayedExamFormList,
  getHisSickLeaveList,
  uploadImage,
  deleteImage,
  submitApplication,
  getApplicationFormDetail
} from "@/api/sickLeave";

export default {
  data() {
    return {
      isEdit: false,
      applyId: null,
      dateRange: [],
      medicalHistory: "",
      formData: {
        hisLeaveFormNo: "",
        deferredExamFormNo: "",
        name: "",
        userNo: "",
        studentNumber: "",
        gender: "",
        collegeNo: "",
        college: "",
        specialtyNo: "",
        specialty: "",
        classNo: "",
        classGrade: "",
        beginTime: "",
        endTime: "",
        description: "",
        flowType: 4,
        visitType: 0,
        educationBackground: "本科",
        address: "",
        reason: "",
        otherReason: "",
        deferredExamCourseList: []
      },
      rules: {
        flowType: [{ required: true, message: "请选择申请类型", trigger: "change" }],
        educationBackground: [{ required: true, message: "请选择学历", trigger: "change" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        college: [{ required: true, message: "请输入学院(系)", trigger: "blur" }],
        specialty: [{ required: true, message: "请输入专业", trigger: "blur" }],
        classGrade: [{ required: true, message: "请输入班级", trigger: "blur" }],
        address: [{ required: true, message: "请输入家庭住址", trigger: "blur" }],
        description: [{ required: true, message: "请输入情况说明", trigger: "change" }],
        reason: [{ required: true, message: "请输入申请缓考理由", trigger: "change" }],
        otherReason: [{ required: true, message: "请输入其他原因说明", trigger: "blur" }],
        hisLeaveFormNo: [],
        deferredExamFormNo: [{ required: true, message: "请选择申请单", trigger: "change" }]
      },
      fileList: [],
      previewVisible: false,
      previewImage: "",
      submitLoading: false,
      userInfo: {},
      collegeList: [],
      specialtyList: [],
      classList: [],
      hisLeaveList: [],
      examFormList: [],
      examFormDrawerVisible: false,
      examFormLoading: false,
      hisLeaveDrawerVisible: false,
      hisLeaveLoading: false,
      courseColumns: [
        { title: "课程名称", dataIndex: "courseName", key: "courseName" },
        { title: "考试日期", dataIndex: "examinationDate", key: "examinationDate" }
      ],
      examFormColumns: [
        { title: "申请日期", dataIndex: "applicationDate", key: "applicationDate" },
        { title: "描述", dataIndex: "description", key: "description" },
        { title: "原因", dataIndex: "reason", key: "reason" },
        { title: "操作", key: "operation", scopedSlots: { customRender: "operation" } }
      ],
      hisLeaveColumns: [
        { title: "疾病诊断", dataIndex: "jbzd", key: "jbzd" },
        { title: "医生姓名", dataIndex: "ysxm", key: "ysxm" },
        { title: "科室名称", dataIndex: "ksmc", key: "ksmc" },
        { title: "时间", dataIndex: "kdsj", key: "kdsj" },
        { title: "操作", key: "operation", scopedSlots: { customRender: "operation" } }
      ],
      leaveReasonList: [
        { label: "个人原因-创业", value: "0" },
        { label: "个人原因-工作实践", value: "1" },
        { label: "个人原因-厌学", value: "2" },
        { label: "个人原因-不适应课程学习", value: "3" },
        { label: "个人原因-不适应校园生活", value: "4" },
        { label: "个人原因-结婚生子", value: "5" },
        { label: "个人原因-精神疾病", value: "6" },
        { label: "个人原因-传染疾病", value: "7" },
        { label: "个人原因-心理疾病", value: "8" },
        { label: "个人原因-其他疾病", value: "9" },
        { label: "家庭原因-经济困难", value: "10" },
        { label: "家庭原因-照顾家人", value: "11" },
        { label: "其他原因(请说明)", value: "12" }
      ]
    };
  },
  created() {
    this.isEdit = this.$route.query.flowNo ? true : false;
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));

    this.applyId = this.$route.query.id;
    this.formData.userNo = this.userInfo.userNo;
    this.formData.studentNumber = this.userInfo.userCode;
    this.formData.userCode = this.userInfo.userCode;
    this.formData.gender = this.userInfo.gender;
    this.formData.phone = this.userInfo.phone;
    this.formData.userName = this.userInfo.userName;
    this.formData.name = this.userInfo.userName;

    if (this.$route.query.flowNo) {
      this.getDetail();
    } else {
      this.getNetworkCenterUserInfo();
    }
  },
  methods: {
    async getNetworkCenterUserInfo() {
      try {
        const { code, data } = await getNetworkCenterUserInfo({});
        if (code === 200 && data) {
          //学历
          this.formData.educationBackground = data.educationBackground || "本科";
          //学院(系)
          this.formData.college = data.dwmc;
          //专业
          this.formData.specialty = data.zymc;
          //班级
          this.formData.classGrade = data.bjmc;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getDetail() {
      try {
        const { code, data } = await getApplicationFormDetail({ formId: this.$route.query.flowNo });
        if (code === 200 && data) {
          this.formData = {
            ...data,
            hisLeaveFormNo: data.visitType == 0 ? data.hisLeaveFormNo : "",
            deferredExamFormNo: data.deferredExamFormNo || "",
            name: data.name || "",
            userName: data.name || "",
            userNo: data.userNo || "",
            studentNumber: data.studentNumber || "",
            gender: data.gender || "",
            collegeNo: data.collegeNo || "",
            college: data.college || "",
            specialtyNo: data.specialtyNo || "",
            specialty: data.specialty || "",
            classNo: data.classNo || "",
            classGrade: data.classGrade || "",
            beginTime: data.beginTime || "",
            endTime: data.endTime || "",
            description: data.description || "",
            flowType: data.flowType || "",
            visitType: data.visitType || "",
            educationBackground: data.educationBackground || "",
            address: data.address || "",
            userCode: data.studentNumber || "",
            reason: data.reason || "",
            otherReason: data.otherReason || "",
            description: data.description || "",
            deferredExamCourseList: data.deferredExamCourseList || []
          };

          if (data.beginTime && data.endTime) {
            this.dateRange = [data.beginTime, data.endTime];
          }

          if (data.thirdMedicalRecordList && data.thirdMedicalRecordList.length > 0) {
            this.fileList = data.thirdMedicalRecordList.map((item, index) => ({
              uid: index,
              name: `image_${index}.jpg`,
              status: "done",
              url: item.medicalRecordImage,
              key: item.medicalRecordImage
            }));
          }

          await this.getNetworkCenterUserInfo();

          if (data.flowType === 1 || data.flowType === 2) {
            await this.getHisLeaveList();
          }

          if (data.flowType === 4) {
            await this.getExamFormList();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getHisLeaveList() {
      this.hisLeaveLoading = true;
      try {
        const { code, data } = await getHisSickLeaveList({ idNumber: this.userInfo.idCard || this.userInfo.passport });
        if (code === 200) {
          this.hisLeaveList = data || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.hisLeaveLoading = false;
      }
    },
    openHisLeaveDrawer() {
      this.hisLeaveDrawerVisible = true;
      this.getHisLeaveList();
    },
    closeHisLeaveDrawer() {
      this.hisLeaveDrawerVisible = false;
    },
    selectHisLeave(record) {
      this.formData.hisLeaveFormNo = record.qjdbh;
      this.medicalHistory = record.jbzd
      this.closeHisLeaveDrawer();
    },
    //查询缓考申请单列表
    async getExamFormList() {
      this.examFormLoading = true;
      try {
        const { code, data } = await getDelayedExamFormList({
          studentNumber: this.userInfo.userCode,
          pageNum: 1,
          pageSize: 999,
        });
        if (code === 200) {
          this.examFormList = data || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.examFormLoading = false;
      }
    },
    openExamFormDrawer() {
      this.examFormDrawerVisible = true;
      //缓考申请单
      this.formData.deferredExamFormNo = "";
      if (this.formData.flowType == 4) {
        this.getExamFormList();
      }
    },
    closeExamFormDrawer() {
      this.examFormDrawerVisible = false;
    },
    selectExamForm(record) {
      this.formData.deferredExamFormNo = record.applicationId;

      this.handleExamFormChange(record);
      this.closeExamFormDrawer();
    },
    handleFlowTypeChange(val) {
      //重置缓考申请单
      this.formData.deferredExamFormNo = "";
      //重置缓考申请单
      this.formData.deferredExamCourseList = [];
      //重置缓考申请单
      this.formData.reason = "";
      //重置缓考申请单
      this.formData.otherReason = "";
      //重置缓考申请单
      this.formData.description = "";
      this.formData.beginTime = "";
      this.formData.endTime = "";

      if (val === 1 || val === 2) {
        this.getHisLeaveList();
      } 
    },
    handleExamFormChange(selectedForm) {
      this.formData.name = selectedForm.name;
      this.formData.userName = selectedForm.name;
      this.formData.phone = selectedForm.phone || "";
      this.formData.gender = selectedForm.gender.toString();
      this.formData.collegeNo = selectedForm.collegeNo
      this.formData.college = selectedForm.college || "";
      this.formData.specialtyNo = selectedForm.specialtyNo
      this.formData.specialty = selectedForm.specialty || "";
      this.formData.classNo = selectedForm.classNo
      this.formData.classGrade = selectedForm.className || "";
      this.formData.description = selectedForm.description || "";
      this.formData.reason = selectedForm.reason || "";
      this.formData.deferredExamCourseList = selectedForm.courseList || [];
      this.formData.studentNumber = selectedForm.studentNumber || "";
      this.formData.userCode = selectedForm.studentNumber;
    },
    handleDateRangeChange(dates) {
      if (dates && dates.length === 2) {
        this.formData.beginTime = dates[0];
        this.formData.endTime = dates[1];
      }
    },
    handleBeginTimeChange(date) {
      this.formData.beginTime = date;
      this.formData.endTime = date;
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("图片大小不能超过5MB");
        return false;
      }
      return isLt5M;
    },
    async handleCustomUpload(options) {
      const { file, onSuccess, onError } = options;
      console.log(file);
      try {
        const formData = new FormData();
        formData.append("file", file);
        const { code, data } = await uploadImage(formData);
        if (code === 200) {
          onSuccess(data);
        } else {
          onError(new Error("上传失败"));
        }
      } catch (error) {
        onError(error);
      }
    },
    handleUploadChange(info) {
      let fileList = info.fileList.filter(file => {
        if (file.status === 'uploading' || file.status === 'done') {
          return true;
        }
        return file.size && file.size / 1024 / 1024 < 5;
      });
      fileList = fileList.slice(-9);
      this.fileList = fileList;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if (this.fileList.length < 2) {
            this.$message.warning("请上传医院疾病诊断证明书、门诊病历或住院病历，最少上传两张");
            return;
          }
          let thirdMedicalRecordList = this.fileList
            .filter(file => file.status === "done")
            .map(file => ({
              medicalRecordImage: file.url || file.key || file.response
            }));

          if (thirdMedicalRecordList.length < 2) {
            this.$message.warning("请上传医院疾病诊断证明书、门诊病历或住院病历，最少上传两张");
            return;
          }

          this.submitLoading = true;
          try {
            const params = {
              opType: this.$route.query.flowNo ? 1 : 0,
              applicationFormOa: {
                ...this.formData,
                beginTime: this.formData.beginTime,
                endTime: this.formData.endTime,
                description: this.formData.flowType === 1 && this.formData.description === "12"
                  ? this.formData.otherReason
                  : this.getLeaveReasonLabel(this.formData.description)
              },
              processDefinitionId: this.applyId,
              thirdMedicalRecordList
            };

            if (this.$route.query.flowNo) {
              params.pid = this.$route.query.flowNo
            }

            const { code, msg } = await submitApplication(params);
            if (code === 200) {
              this.$message.success("提交成功");
              this.$router.push({
                path: "/sick-leave-success",
                query: { flowType: this.formData.flowType }
              });
            } else if (code == 500 && msg == "请从已拒绝中选择申请单补充资料") {
              this.$dialog.confirm({
                title: "提示",
                message: "该申请单已被拒绝，是否去补充资料？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                this.$router.go(-1);
              });

            }
          } catch (error) {
            console.error(error);
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    handleBack() {
      this.$router.back();
    },
    getLeaveReasonLabel(value) {
      const found = this.leaveReasonList.find(item => item.value === value);
      return found ? found.label : value;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .notice-scroll {
    width: 100%;
    background: linear-gradient(90deg, #e6f7ff 0%, #f0f7ff 100%);
    border-left: 4px solid #1890ff;
    padding: 12px 0;
    margin: 20px 0;
    overflow: hidden;

    .notice-content {
      display: inline-block;
      white-space: nowrap;
      animation: scrollNotice 30s linear infinite;
      font-size: 14px;
      color: #333;
      line-height: 1.6;

      .notice-item {
        display: inline-block;
        padding: 0 40px;
      }
    }
  }

  .content-box {
    max-width: 900px;
    margin: 30px auto;
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .form-header {
    margin-bottom: 30px;
    text-align: center;

    h2 {
      font-size: 24px;
      color: #333;
    }
  }

  .upload-tips {
    color: #666;
    font-size: 14px;
    margin-top: 12px;
    line-height: 1.6;

    .warning {
      color: #ff4d4f;
      font-weight: bold;
    }
  }
}

@keyframes scrollNotice {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}
</style>